// rewrite dates as yyyy-mm-dd

export default function readableDate(input, lang) {
  let date = new Date(input.replace(' ', 'T'))
  date = date.toLocaleDateString(lang, { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '.')
  return date
}
